import React from "react";
import LeagueContainerUpComing from "../containers/LeagueContainerUpComing";

function UpcomingMatches() {
  return <LeagueContainerUpComing></LeagueContainerUpComing>;
}

export default UpcomingMatches;
